import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

// Server-rendered share pages (carry proper preview tags for WhatsApp / Facebook / LinkedIn)
export const SHARE = {
  priceSheet: `${API}/share/price-sheet`,
  product: (slug) => `${API}/share/product/${encodeURIComponent(slug)}`,
  productImage: (slug, v = "") => `${API}/products/${encodeURIComponent(slug)}/share-image.jpg${v ? `?v=${v}` : ""}`,
};

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      ta.remove();
      return ok;
    } catch (err) {
      return false;
    }
  }
};
